<template>
  <Layout>
    <div class="row justify-content-center loginx pt-5 mt-5">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden bg-white">
          <div class="">
            <div class="row">
              <div class="col-sm-12 text-center">
                <img
                  src="@/assets/images/xbit-login3.png"
                  alt
                  class="img-fluid p-4 mt-4"
                  width="300px"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="form-horizontal">
              <div class="text-light">
                <h5 class="text-light text-center">
                  Two Factor Authentication
                </h5>
                <p class="p-0 pt-4">
                  <b-alert
                    show
                    dismissible
                    :variant="resend.success ? 'success' : 'danger'"
                    v-if="resend.status"
                    @dismissed="resend.status = false"
                    >{{ resend.message }}</b-alert
                  >
                  <b-alert show dismissible variant="danger" v-if="failed">
                    <i class="bx bx-error-alt mr-2"></i>{{ errMessage }}
                  </b-alert>
                  <span class="text-justify">{{ pageMessage }}</span>
                </p>
              </div>
              <div class="form-group">
                <label for="userpassword" class="text-light">OTP Code</label>
                <input
                  style="
                    letter-spacing: 10px;
                    text-align: center;
                    color: #000;
                    border: 2px solid #e7e9eb;
                  "
                  v-model="otpcode"
                  v-mask="'######'"
                  type="text"
                  class="bg-white form-control"
                  id="userpassword"
                  placeholder="******"
                />
              </div>

              <div
                class="text-center text-light pb-5"
                v-if="type == 0 && type != ''"
              >
                Haven't received it?
                <span class="text-info hoverable" @click="resendOtpCode">
                  <span v-if="!loading.resend">Resend a new code.</span>
                  <span v-if="loading.resend">Sending new otp code ...</span>
                </span>
              </div>

              <div class="form-group row mb-0">
                <div class="col-12 text-right">
                  <span
                    class="mr-3 text-light align-middle"
                    v-if="loading.redirect"
                  >
                    <i class="bx bx-loader-alt bx-spin"></i>
                    Redirecting...
                  </span>
                  <button
                    class="btn btn-primary w-md"
                    @click="verifyOtpCode"
                    :disabled="loading.verify"
                  >
                    <span v-if="loading.verify"> Verifying... </span>
                    <span v-if="!loading.verify"> Verify </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p class="text-white">
            © {{ new Date().getFullYear() }}
            <!-- <i class="mdi mdi-heart text-danger"></i> Crafted with by Themesbrand -->
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/auth";
import { userService } from "@/helpers/authservice/user.service";
import { authBackendMethods, notificationMethods } from "@/state/helpers";

import appConfig from "@/app.config";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      type: this.$route.query.ty,
      token: this.$route.query.q,
      pageMessage: "Enter the otp code to verify yourself",
      otpcode: "",
      errMessage: "Something went wrong!",
      failed: false,
      loading: {
        verify: false,
        redirect: false,
        resend: false,
      },
      resend: {
        success: false,
        status: false,
        message: "",
      },
    };
  },
  validations: {},
  computed: {},
  created() {},
  mounted() {
    this.setMessage();
  },
  methods: {
    ...authBackendMethods,
    ...notificationMethods,
    verifyOtpCode() {
      if (this.token != null && this.otpcode != "") {
        const verifData = {
          tfa_token: this.token,
          otp: this.otpcode,
        };
        this.loading.verify = true;
        userService
          .verifyOtp(verifData)
          .then((res) => {
            this.loading.redirect = true;
            let user = res.data.data;
            let responseJson = {
              user: {
                name: user.name,
                username: user.username,
                email: user.email,
                avatar: user.avatar,
              },
              id: user.id_user,
              role: user.role,
              token: res.data.access_token,
            };
            userService.setToken(responseJson);
            this.tfalogin(responseJson);
            localStorage.setItem("tfa_key", res.data.data.tfa.token);
            setTimeout(() => {
              this.$router.push("/");
            }, 2000);
            setTimeout(() => {
              this.loading.redirect = false;
              this.loading.verify = false;
            }, 3500);
          })
          .catch((err) => {
            this.loading.verify = false;
            this.loading.redirect = false;
            this.failed = true;
            this.errMessage = err.response
              ? err.response.data.errors.message
              : "Something went wrong!";
          });
      }
    },
    resendOtpCode() {
      if (this.token != null) {
        const verifData = {
          tfa_token: this.token,
        };
        this.loading.resend = true;
        userService
          .resendOtp(verifData)
          .then((res) => {
            this.resend.status = true;
            this.resend.success = true;
            this.resend.message = "Success resend otp code.";
            this.loading.resend = false;
          })
          .catch((err) => {
            this.resend.status = true;
            this.resend.success = false;
            this.resend.message = "Failed resend otp code.";
            this.loading.resend = false;
          });
      }
    },
    setMessage() {
      if (this.type == 0 && this.type != "") {
        this.pageMessage =
          "We have sent otp code to your authentication email. Use that code to get access to your account.";
      }
      if (this.type == 1 && this.type != "") {
        this.pageMessage =
          "Enter the otp code in your authentication app to get access to your account.";
      }
    },
  },
};
</script>

<style scope>
body {
  /* background-color: #2C2E43; */
  padding: 0;
  margin: 0;
}
.img-fluid {
  height: 195px;
}
.field-icon {
  float: right;
  margin-left: -25px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
  margin-right: 10px;
}
.hoverable:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #2093d4;
}
</style>